import { render, staticRenderFns } from "./SystemStatus.vue?vue&type=template&id=20809b38&scoped=true"
import script from "./SystemStatus.vue?vue&type=script&lang=js"
export * from "./SystemStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20809b38",
  null
  
)

export default component.exports